function BarChart($) {
  'use strict';

  const $charts = $('.js-chart-bar');

  const barChart = ctx => {
    const data = ctx.data();
    return new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: data.values
      },
      options: {
        title: {
          display: !!data.title,
          text: data.title
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              stacked: data.stacked,
              display: true,
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              },
              scaleLabel: {
                display: !!data.xTitle,
                labelString: data.xTitle
              },
              ticks: {
                callback: value => {
                  if (String(data.xLabelsHidden) === 'true') {
                    return '';
                  }

                  let count = data.xLabelsMaxChars;

                  if (count) {
                    return value.substring(0, Number(count));
                  }

                  return value;
                }
              }
            }
          ],
          yAxes: [
            {
              stacked: data.stacked,
              display: true,
              gridLines: {
                color: 'rgba(0, 0, 0, 0.1)'
              },
              scaleLabel: {
                display: !!data.yTitle,
                labelString: data.yTitle
              },
              ticks: {
                min: data.yMin,
                max: data.yMax,
                stepSize:
                  (data.yMax - data.yMin) / data.yStep > 10 ? null : data.yStep,
                maxTicksLimit: 10,
                callback: value => {
                  if (String(data.yLabelsHidden) === 'true') {
                    return '';
                  }
                  return value;
                }
              }
            }
          ]
        },
        plugins: {
          stacked100: { enable: data.stacked100 }
        }
      }
    });
  };

  vendorManager.ensure('chart.js', () => {
    $charts.each((i, chart) => {
      barChart($(chart));
    });
  });
}

BarChart(jQuery);

export default BarChart;
